import { getURI } from "@src/api/apiConfig";
import { UserContext } from "@src/context/UserContext";
import { useContext, useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setImpersonationMode } from "@features/session/sessionSlice";
import { generateCorrelationId } from "@src/helpers/generateCorrelationId";
import { log } from "../../Log.init"

const useLogout = () => {
  const [userContext, setUserContext] = useContext(UserContext);
  const dispatch = useDispatch();

  const fetchLogout = useCallback(async () => {
    try {
      const headers = new Headers();
      headers.append('Authorization', `Bearer ${userContext.token}`);
      headers.append('Content-Type', 'application/json');
      headers.append('X-Correlation-ID', generateCorrelationId());
      const response = await fetch(getURI("logout"), {
        credentials: "include",
        headers
      });

      setUserContext((oldValues) => {
        return { ...oldValues, details: undefined, token: null };
      });

      dispatch(setImpersonationMode(false));
      window.localStorage.setItem("logout", Date.now());
    } catch (error) {
      log.error({ message_type: 'General', message: `error: Logout Error: ${error.message}`});
    }
  }, []);

  return { fetchLogout };
};

export { useLogout };
